/**
 * Redirect old /booking/[slug] URLs to new SEO-friendly URLs
 * - /omra/[slug] for regular Omra packages
 * - /omra-ramadhan/[slug] for Ramadhan packages
 *
 * This maintains backward compatibility and SEO juice via 301 redirects
 */
import { logger } from "~/utils/logger";

export default defineNuxtRouteMiddleware(async (to) => {
  // Only handle /booking/[slug] routes (not /booking/payment, etc.)
  if (!to.path.startsWith("/booking/")) return;

  // Skip payment and other sub-routes
  if (to.path.includes("/payment") || to.path.includes("/confirmation")) return;

  // Extract slug from path
  const pathParts = to.path.split("/");
  if (pathParts.length !== 3) return; // Only handle /booking/[slug]

  const slug = pathParts[2];
  if (!slug) return;

  try {
    // Fetch package to determine its category
    const pkg = await $fetch<any>(`/api/packages/${slug}`);

    if (!pkg) return; // Let it 404 naturally

    // Determine the correct route based on category
    const category = pkg.category || "omra";
    let newPath: string;

    if (category === "omra-ramadhan") {
      newPath = `/omra-ramadhan/${slug}`;
    } else {
      newPath = `/omra/${slug}`;
    }

    // Preserve query params
    const queryString =
      Object.keys(to.query).length > 0
        ? "?" +
          new URLSearchParams(to.query as Record<string, string>).toString()
        : "";

    // 301 redirect for SEO
    return navigateTo(newPath + queryString, {
      redirectCode: 301,
      external: false,
    });
  } catch (error) {
    // If package fetch fails, let it continue to potentially 404
    logger.error("[booking-redirect] Error fetching package:", error);
    return;
  }
});
